import Chart from 'chart.js/auto';
import * as GLOBALS from '../globals';

export default class ChartClass {
    colors = [
        '#86b5db',
        '#74b959',
        '#1b508e',
        '#00638e',
        '#a4dcee',
        '#afb212',
        '#7c7e00'
    ];

    static init() {
        return new ChartClass();
    }

    constructor() {
        const chartElements = document.querySelectorAll('.chart-wrapper canvas');

        chartElements.forEach((chartElement) => {
            const chartType = chartElement.dataset.chartType;
            const labels = JSON.parse(chartElement.dataset.chartLabels);
            const chartData = JSON.parse(chartElement.dataset.chartData); 
            const stacked = chartElement.dataset.stacked || false;
            let colorIndex = 0;
            const datasets = Object.entries(chartData).map(([key, value]) => {
                colorIndex = colorIndex % this.colors.length;
                if (chartType == 'pie') {
                    return {
                        label: key,
                        data: value,
                        backgroundColor: this.colors,
                    };
                } else {
                    return {
                        label: key,
                        data: value,
                        borderColor: this.colors[colorIndex],
                        backgroundColor: this.colors[colorIndex++],
                    };
                }
            });
            
            Chart.defaults.font.family = "'Montserrat', sans-serif";
            Chart.defaults.color = '#003247';
            Chart.defaults.font.size = 14;
            Chart.defaults.borderColor = '#a4dcee';

            const chart = new Chart(chartElement, {
                type: chartType,
                responsive: true, 
                data: {
                    labels: labels,
                    datasets: datasets,
                },
                options: {
                    layout: {
                        padding: GLOBALS.BREAKPOINT_MD > window.innerWidth ? 16 : 32
                    },
                    scales: chartType != 'pie' ? {
                        x: {
                            stacked: stacked
                        },
                        y: {
                            stacked: stacked
                        }
                    } : {},
                    responsive: true,
                    maintainAspectRatio: GLOBALS.BREAKPOINT_MD < window.innerWidth
                }
            });
        })
    }
}